export const AppName = 'inner stance'
export const constants = {
  programs: "Programs",
  OFFSET: 0,
  LP_PAGE_LIMIT: 10,
  FUNDAMENTAL_PROGRAM: 'learningProgram%3A60590',
  PROGRAM_COMPLATION: 100,
  COURSE_STATUS: 'COMPLETED',
  COMPLETED: 'COMPLETED',
  STARTED: 'STARTED',
  YEARLY: 'YEARLY',
  BOOKS: 'Books',
  DOCUMENT: 'Document',
  BULLETIN: 'BulletIn',
  VIDEOS: 'Videos',
  PODCAST: 'Podcast',
  UPVOTE: 'UPVOTE',
  DOWNVOTE: 'DOWNVOTE',
  UP: 'UP',
  DOWN: 'DOWN',
  DELETED: 'DELETED',
  NEW_VIDEO: 'New Video',
  NEW_BULLETINS: 'New Bulletin',
  BULLETINS: 'Bulletins',
  DOCUMENTS: 'Documents',
  SEE_MORE_LIMITS: 19,
  SEE_MORE_PATHNAME: '/home/library',
  SEE_MORE_PATHNAME1: '/home/my-stance',
  SEE_MORE_PATHNAME2: '/home',
  NEW_DOCUMENT: 'New Document',
  MY_BOOKMARK: 'bookmark',
  S_BOOKS: 'books',
  S_DOCUMENT: 'documents',
  S_BULLETIN: 'bulletins',
  S_VIDEOS: 'videos',
  S_PODCAST: 'podcasts',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CREATED_BY: 'createdBy',
  ACHIEVEMENTS: 'Achievements',
  ANNUALLY: 'Annually',
  MONTHLY: 'Monthly',
  P_DOCUMENTS: 'Documents',
  P_VIDEOS: 'Videos',
  P_EXERCISE: 'Exercise',
  MYSTANCE_FUNDAMENTAL_PROGRAM: 'Fundamental Program',
  LIVE_PROGRAM_COUNT: 12,
  LIVE: 'LIVE',
  UPCOMING: 'UPCOMING',
  NEXT: 'NEXT',
  PAST: 'PAST',
  WEB: 'web',
  DEVICE_TYPE: 'web',
  DEVICE_MODEL: 'NA',
  login: 'login',
  logout: 'logout',
  englishLocale: 'en-US',
  dutchLocale: 'nl-NL',
  english: 'English',
  dutch: 'Dutch',
  englishCode: 'en',
  dutchCode: 'nl',
  default: 'default',
  secondary: 'secondary',
  weekCount: '13',
  notificationTab: 'notificationsTab',
  course: 'course',
  BASE_URL: 'https://www.innerstance.com',
  others: "others",
  courseType: "courseType",
  relatedId: "relatedId",
  filterTag: "filterTag",
  relatedContent: "relatedContent",
  doNotShow: 1,
  PUBLISHED: "PUBLISHED",
  ACTIVITY: "Activity",
  RECOMMENDED: "Recommended",
  MEETING: "Meeting",
  EXERCISE: "Exercise",
  LEARNING_OBJECT: "learningObject",
  BASIC_PROGRAM: "basic-program",
  LIVE_PROGRAM: "live-program",
  recording: "recording",
  meetingAlreadyCompleted: "meetingAlreadyCompleted",
  liveEvent: "Live Events",
  DOCUMENTS_AND_BULLETINS: "Documents & Bulletins",
  time: 'time',
  RETERIED: "Retired",
  NEW_PODCASTS: "New Podcasts",
  DAILYREMINDER_LIMIT: 100,
  Custom: "Custom",
  Social: "Social",
  EMAIL_UPDATED:"EMAIL_UPDATED",
  DONE:"Done",
  INACTIVE_SESSION_TIME_CHECK_SLEEP_MODE: 60000,
  PERIODIC_TIME_CHECK_SLEEP_MODE: 5000,
  DECIMAL_RADIX: 10,
  EXPIRY_TIME_PARSE_BASE: 10,
  INCOMPLETE:"INCOMPLETE",
  STATUS_CHECK_TIME:2000
};
export const ActionType = {
  INIT_APP: 'INIT_APP',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  IS_AUTH: 'IS_AUTH',
  SET_STEP: 'SET_STEP',
  SET_SUBSCRIPTION: 'SET_SUBSCRIPTION',
  ERROR: 'ERROR',
  SET_LOADING: 'SET_LOADING',
  EU_ALM_USER_INFO: 'EU_ALM_USER_INFO',
  CLEAR_CONTEXT: 'CLEAR_CONTEXT',
  PROFILE_CHANGE: 'PROFILE_CHANGE',
  UPADTE_ROUTE: 'UPADTE_ROUTE',
  ENROLLED_PROGRAM_DATA: 'ENROLLED_PROGRAM_DATA',
  LIVE_QUATER_LP_DATA: 'LIVE_QUATER_LP_DATA',
  SET_ENROLLMENT: 'SET_ENROLLMENT',
  SET_QUARTER_DETAIL: 'SET_QUARTER_DETAIL',
  LIBRARY_DATA: 'LIBRARY_DATA',
  SEARCH_LIBRARY_DATA: 'SEARCH_LIBRARY_DATA',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  UPDATE_USER_PROFILE_NAME: 'UPDATE_USER_PROFILE_NAME',
  GET_CURRENT_QUATER_DETAILS: 'GET_CURRENT_QUATER_DETAILS',
  SET_CURRENT_USER_TIMEZONE: 'SET_CURRENT_USER_TIMEZONE',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  NOTIFICATION_SETTING: 'NOTIFICATION_SETTING',
  IS_SOCIAL_LOGIN: 'IS_SOCIAL_LOGIN',
  SET_CATELOG: "SET_CATELOG",
  CONTENT_LOADING: "CONTENT_LOADING",
  CURRENT_USER_DATA: "CURRENT_USER_DATA",
  SELECTED_MEMBERSHIP: "SELECTED_MEMBERSHIP",
  CURRENT_QUARTER_LIVE_PROGRAM_TAG: "CURRENT_QUARTER_LIVE_PROGRAM_TAG",
  NEXT_QUARTER_LIVE_PROGRAM_TAG: "NEXT_QUARTER_LIVE_PROGRAM_TAG",
  ALERT_BOX: "ALERT_BOX",
  GET_ALL_MEMBERSHIPS: "GET_ALL_MEMBERSHIPS",
  PROGRAM_OPTIONS: "PROGRAM_OPTIONS",
  LIVE_PROGRAMS: "LIVE_PROGRAMS",
  CHAT_BOT_STATE: "CHAT_BOT_STATE",
  REFETCH_PROGRAM_DTATA: "REFETCH_PROGRAM_DTATA",
  FUNDAMENTAL_PROGRAM_ID: "FUNDAMENTAL_PROGRAM_ID",
  LOTTIE_ANIMATION: "LOTTIE_ANIMATION",
  TRIAL_OVER: 'TRIAL_OVER',
  CUSTOM_LOGIN: "CUSTOM_LOGIN",
  SESSION_TIMEOUT_POPUP: "SESSION_TIMEOUT_POPUP",
  SET_DISABLE: 'SET_DISABLE',
  SET_KEYWORD: 'SET_KEYWORD',
  GLOBAL_CHATBOT_KEY: 'SET_CHATBOT',
  CORPORATE_LOGIN: "CORPORATE_LOGIN",
  SET_ENROLLED_PROGRAM:'SET_ENROLLED_PROGRAM',
  GLOBAL_CHATBOT_KEY_LOGOUT: "GLOBAL_CHATBOT_KEY_LOGOUT",

};
export const DateFormat = 'MMM DD YYYY';
export const CurrencyOptions = ['EUR', 'USD', 'GBP'];
export const CurrencySymbol: { [k: string]: any } = {
  eur: '€',
  usd: '$',
  gbp: '£',
};
export const Variant = {
  SUCCESS: 'success',
  success: "Success"
};
export const StatusCode = {
  SUCCESS: 200,
  ERR_BAD_REQUEST: 400,
  UN_AUTHORIZED: 401,
  ERR_NETWORK: "ERR_NETWORK",
  USER_NOT_PRESNT_IN_ALM:"UserNotFoundInALM",
  USER_SYNC_STATUS: "EMAIL_UPDATED",
  USER_ACTIVE_STATUS: "Forbidden",
  FORBIDDEN:"403"
  
};
export const DeviceDetailActionType: { [k: string]: any } = {
  login: 'login',
  logout: 'logout',
};
export const CompletedProgramsLottieImage = {
  CompletedPrograms: '',
};
export const Tag = {
  liveclass: "liveclass",
  liveEvent: "liveevent",
  exercise: "Exercise",
  doNotShow: "do-not-show",
  introductionVideo: "Introduction-video",
  videos: "Videos",
  videoTutorial: "Video Tutorials",
  releaseDate: 'releasedate',
  documents: 'Documents',
  overviewIntroVideo: 'Overview-introduction-video',
  mainProgram: 'MainProgram',
  defaultProgram:'DefaultProgram'
};
export const FileNotation = {
  badge: "badge.lottie.json",
  finish: "finish.lottie.json",
  lottie: "lottie.json",
  exercise: "exercise.lottie.json",
  transcript: "transcript.txt",
};

export const LiveMeetingInt = 16;
export const Minutes = 'minutes';

export const TabConstants = {
  defaultTab: 'overview',
  discussion: 'discussion',
  transcripts: 'transcripts',
  myNotes: 'mynotes',
  billing: 'billing',
  notifications: 'notifications',
};
export const LocationPathname = {
  courseDetail: 'course-detail',
};

export const FreeTrialPrice = 0;

export const Languages = [
  {
    locale: constants.englishLocale,
    value: constants.englishCode,
    label: constants.english,
  },
  {
    locale: constants.dutchLocale,
    value: constants.dutchCode,
    label: constants.dutch,
  },
];
export const invalidDateString = 'Invalid date undefined';
export const SubscriptionStatus = {
  pending: 'PENDING',
  canceled: 'CANCELLED',
  active: 'ACTIVE',
  trial: 'TRIAL',
  trialOver: 'TRIAL_OVER'
};


export const notificationSettingsSelected = ['certification::badgeIssued', 'course::completed', 'course::sessionReminder', 'learningProgram::badgeIssued', 'learningProgram::completed', 'social::commentedOnPost', 'social::commentedOnComment', 'social::postUploadFailed', "course::badgeIssued", "course::completionReminder", "learningProgram::adminEnrollment", "learningProgram::autoEnrollment"]

export const daysBeforeNextQuarterProgram = 7;
export const NotificationChannel = {
  learningProgramCompleted: 'learningProgram::completed',
  courseCompleted: 'course::completed',
  socialCommentedOnPost: 'social::commentedOnPost',
  announcementReceived: 'announcement::received',
  learningProgramAutoEnrollment: 'learningProgram::autoEnrollment',
}
export const ErrorType = {
  tokenExpired: 'tokenExpired',
  invalidRequest: 'invalidRequest',
  unauthorized: 'Unauthorized',
  programEnrollment: 'programEnrollment',
  networkError: "networkError",
  invalidData: 'invalidData',
  almTokenGenratingIssue: 'almTokenGenratingIssue',
  coginitoTokenGenratingIssue: 'coginitoTokenGenratingIssue',
  unknonwError: 'unknonwError',
  courseNotFound: 'courseNotFound',
  enrollment: "enrollment"
};
export const ActiveWeek = 'activeWeek';
export const FUNDAMENTAL_PROGRAM = "Fundamental Program";
export const FUNDAMENTAL = "Fundamental";
export const APPROUTES = {
  coachTool: "/coach-tool",
  home: "/home",
  myStance: '/home/my-stance',
  changePassword: '/update-password',
  library: "/home/library",
  bookmark: "/bookmark",
  videoTutorials: "/tutorialVideos",
  membershipSuccess: "/membership-success",
  profile: '/profile',
  startLearning: '/start-learning',
  membershipFailure: '/membership-failure',
  selectCurrency: '/select-currency',
  selectMembership: '/select-membership',
  personalizedUpdates: '/personalized-updates',
  userSettings: '/user-settings',
  error: "/error",
  video_tutorials: "/video-tutorials",
  verification: '/verification',
  signIn: '/sign-in',
  verificationAccount: '/verification/account',
  verificationSignIn: '/verification/signIn',
  programOverview: '/program-overview',
  program: '/program',
  recomendedContent: "/recommended-content",
  isHome: 'isHome',
  termsAndConditions: "/terms-of-services",
  privacyPolicy: "/privacy-policy",
  cookieSetting: "/cookie-setting",
  libraryCourseDetails: "/home/library/library-course",
  quarterList: "/home/quater-list",
  setupPassword:'/setup-password',
  signOut:'/sign-out',
  resetPassword:'/reset-password',

}


export const podCastTags = {
  newPodcasts: "New Podcasts",
  innerSTancePodcasts: "Inner Stance Podcasts",
  straightLinePodcasts: "Straight-Line Podcasts",
  specialPodcasts: "Special Podcasts"

};
export const BackendRespose = {
  alreadySubscribed: 'already subscribed',
  unknownErrorOccured: 'UnknownErrorOccured',
  notAuthorizedException: 'NotAuthorizedException',
  detailsNotFound: 'DetailsNotFound',
  subscriptionExpired:'subscriptionExpired',
  accountDeletedMessage:'accountDeletedMessage',
  accountDeactivatedMessage:'accountDeactivatedMessage',
  userNotFoundError:'userNotFoundError'
}

export const CognitoResponse = {
  confirmSign: 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE',
  done: 'DONE',
  notAuthorizedException: 'NotAuthorizedException',
  codeMismatchException: 'CodeMismatchException',
  signInException: 'SignInException',
  userNotFoundException: "UserNotFoundException",
  confirmSignWithPasswordRequired:'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  error:{
    userNotExist:'Incorrect username or password.',
    attemptLimitExceeded:'Password attempts exceeded',
    otpExpired:'',
    userDoesNotExists:'User does not exist.'
  }
}
export const initialState: any = {
  user: null,
  isAuthenticated: false,
  loading: false,
  openFrame: false,
  isOpenFrame: false,
  token: '',
  signUpStep: 0,
  username: '',
  password: '',
  subscription: null,
  error: null,
  updateProfile: null,
  sllSubscriptionStatus: null,
  initApp: false,
  history: '',
  enrolledProgramData: { enrollment: false, enrolledProgram: [] },
  isEnrolledDisable: false,
  isEnrollmentOpen: false,
  libraryData: {
    Videos: [],
    Bulletins: [],
    Documents: [],
    Podcast: [],
    Books: [],
    'DailyReminder': [],
  },
  liveQuarterData: [],
  searchLibraryData: {
    Videos: [],
    Bulletin: [],
    Documents: [],
    Podcast: [],
    Books: [],
    'DailyReminder': [],
  },
  validationError: '',
  enrollmentData: '',
  notifications: [],
  notificationCount: 0,
  isNext: false,
  settings: {},
  isSocialLogin: false,
  contentLoading: false,
  lottieAnimation: false,
  fundamenalCatlogId: '',
  catlogList: [],
  fundamentalId: '',
  refetchProgramData: false,
  alertBox: {
    visible: false,
    heading: null,
    title: null,
    message: null,
  },
  sessionTimeoutPopup: {
    visible: false,
    heading: null,
    title: null,
    message: null,
  },
  loginDetail: null,
  keyword: '',
  globalChatBotkey: false,
  corporateDetails:null,
  isEnrolledProgram: false,
  chainlit_chat_bot:false
};
export const PLIVETIME = '10:00:00';
export const SET_VERIFICATION_CODE_INTERVAL = 31 * 60 * 1000 //31 minutes timer
export const SESSION_TIMEOUT_DURATION = 180 * 60 * 1000;
export const SET_POPUP_TIMEOUT_DURATION = Number(import.meta.env.VITE_POPUP_TIMEOUT_DURATION) || 10800000; // Fallback to 10 minutes if not set in .env -# 3 hours (10,800,000 ms)
export const SET_POPUP_IDEAL_TIMEOUT_DURATION = Number(import.meta.env.VITE_POPUP_IDEAL_TIMEOUT_DURATION) || 900000; // Fallback to 5 minutes if not set in .env # 15 minutes (900,000 ms)
export const INACTIVE_SESSION_TIME_CHECK_SLEEP_MODE = 60000; // 1 minute - check interval for sleep mode

export const Week = 7;
export const DUTCH_LANG_COUNTRIES = ['nl', 'nld', 'be', 'bel'];

export const UserType = {
  STANDARD: 'STANDARD',
  SOCIAL: 'SOCIAL'
};

export const DO_NOT_SHOW_FINISH = ["Performance-Coaching"]

// All of  parameters should be listed `ParamMeters` variables  
export const ParamMeters = {
  sessionExpire: 'sessionExpire'
};

export const ApiErrorCode = {
  objectDoesntExist: "OBJECT_DOESNT_EXIST"
};

export const PodcastTags: any = [
  'New Podcasts',
  'Inner Stance Podcasts',
  'Straight-Line Podcasts',
  'Special Podcasts',
];

export const AppcuesConstant: any ={
  weekComplete : "Week Complete",
  otherContent : "Other Content",
  profileCompletePercent : "100%",
  profileNotCompletePercent : "80%",
  DataFromLibrary:"Data From Library",
  exercise:"exercise",
  Exercise:"Exercise",
  meeting: "Meeting"
}
export const corporateKeys={
  CORPORATE_OWNER:"CORPORATE OWNER",
  CORPORATE_LEARNER:"CORPORATE LEARNER",
  LEARNER:"LEARNER",
  CORPORATE_ADMIN:'CORPORATE ADMIN',
  CORPORATE_OWNER_STATUS:"CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  CORPORATE_URL:import.meta.env.VITE_CORPORATE_ADMIN_MANAGEMENT_URL
}

export const CorporateUser= true;
export const SuperUsers= ['Admin', 'Author'];

export const ROUTES = {
  TERMS: "/terms-of-services",
  PRIVACY: "/privacy-policy",
  COOKIE: "/cookie-setting",
};
export const toBeExcluded=['/', '/sign-up','/redrection','/setup-password','/select-currency','/reset-password','/membership-success','/start-learning','/personalized-updates','/membership-failure',
  '/select-membership','/profile',APPROUTES.resetPassword
]

export const RANDOM_STRING_LENGTH = 10;
export const excludedKeys:any = ["access_token", "login_time", "token"];

